const toggle_icon = document.querySelector(".cstm-nav-toggle");
const menu_drawer = document.querySelector(".cstm-nav-toggle");
const header = document.querySelector(".cstm_transparent_header");

toggle_icon?.addEventListener("click", () => {
  // if (toggle_icon.classList.contains("cstm-shift-right")) {
  //   toggle_icon.classList.remove("cstm-shift-right");
  //   toggle_icon.classList.add("cstm-shift-left");
  // } else {
  //   toggle_icon.classList.remove("cstm-shift-left");
  //   toggle_icon.classList.add("cstm-shift-right");
  // }
  if(header.classList.contains("cstm_header_color")){
    header.classList.remove("cstm_header_color");
  } else {header.classList.add("cstm_header_color");}
})

const var_modal_opener = document.getElementById('variant_modal_opener');

var_modal_opener?.addEventListener('click', function() {
  let modal_dialog = document.querySelector('.cstm-variant-modal').setAttribute('var-open', '');
});

document.querySelector('.cstm-variant-close')?.addEventListener('click', function() {
  let modal_dialog = document.querySelector('.cstm-variant-modal').removeAttribute('var-open');
});

let modal_dialog = document.querySelector('.cstm-variant-modal');
  modal_dialog?.addEventListener('click', function() {
    if (modal_dialog.hasAttribute('var-open')) {
    let modal_dialog = document.querySelector('.cstm-variant-modal').removeAttribute('var-open');
    }
});
